import { Injectable } from '@angular/core';
import { getAuth, signInAnonymously, onAuthStateChanged, User } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { BehaviorSubject } from 'rxjs';
import { firebaseConfig } from '../../environments/firebase-config';

@Injectable({
  providedIn: 'root'
})
export class FirebaseAuthService {
  private auth = getAuth(initializeApp(firebaseConfig));
  private userSubject = new BehaviorSubject<User | null>(null);
  user$ = this.userSubject.asObservable();

  constructor() {
    onAuthStateChanged(this.auth, (user) => {
      if (user) {
        this.userSubject.next(user);
      } else {
        this.signIn();
      }
    });

    this.signIn();
  }

  private signIn(): void {
    signInAnonymously(this.auth)
      .then((result) => {
        this.userSubject.next(result.user);
      })
      .catch((error) => {
        console.error('Authentication error:', error);
      });
  }

  getUserId(): string | null {
    return this.userSubject.value?.uid ?? null;
  }
}
